import React from 'react'

const Review = (props) => {
  return (
    <div className="w-4/5 p-10">
        <div className=" p-5 mx-auto text-white text-lg">{props.content}</div>
        <div className=" p-4 font-semibold text-[#d2a960] text-2xl">{props.title} </div>
        <div className=" p-2 text-white text-lg">{props.subtitle}</div>
    </div>
  )
}
export default Review